import { Component, Input } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

@Component({
    selector: 'app-modal-warning',
    template: `
        <nb-card class="modal-warning-card">
            <nb-card-header>{{title}}</nb-card-header>
            <nb-card-body class="modal-warning-body">
                <p>{{message}}</p>
                <ng-container *ngIf="subMessage">
                    <p class="sub-message">{{subMessage}}</p>
                </ng-container>

            </nb-card-body>
            <nb-card-footer class="modal-warning-footer">
                <button *ngIf="showCancel" nbButton size="large" class="mr-3 h-30"  (click)="cancel()">{{ cancelText }}</button>
                <button nbButton size="large" class="mr-3 h-30" status="primary" (click)="confirm()">{{ confirmText }}</button>
            </nb-card-footer>
        </nb-card>
    `,
    styles: [`
        .modal-warning-card {
            width: 426px;
            max-width: 100%;
            border-radius: 20px;
            background-color: var(--my-color-white);
            box-shadow: 0 2px 16px rgba(0,0,0,0.12);
        }
        .modal-warning-card nb-card-header {
            background-color: var(--my-color-dark-grey);
            color: #ffffff;
            text-align: center;
            font-weight: bold;
            font-size: 1.2rem;
            border-radius: 20px 20px 0 0;
            padding: 1rem;
        }
        .modal-warning-body {
            font-size: 16px;
            color: var(--my-color-black);
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            min-height: 80px;
            padding-bottom: 0;
            flex-direction: column;
        }
        .modal-warning-footer {
            display: flex;
            justify-content: space-around;
            padding: 1rem;
        }
        .modal-warning-footer button[nbButton] {
            width: 30%;
            font-weight: bold;
            border-radius: 8px;
            font-size: 13px;
            height: 30px;
        }

    `]
})
export class ModalWarningComponent {
    @Input() title: string = 'Confirmación';
    @Input() message: string = '¿Estás seguro?';
    @Input() subMessage?: string;
    @Input() showCancel: boolean = true;
    @Input() cancelText: string = 'Cancelar';
    @Input() confirmText: string = 'Confirmar';

    constructor(protected ref: NbDialogRef<ModalWarningComponent>) { }

    confirm() {
        this.ref.close(true);
    }

    cancel() {
        this.ref.close(false);
    }
}
